export default __webpack_public_path__ + "static/icon-male-c073ef9e13c39e0aabab7b4cafa8e338.png";